import { PartComponent } from "../../reference/models/part-component";
import { CorrectionEstimate } from "./estimates/correction-estimate";

// The concern, cause, and part (component) with correction estimates grouped.
export class ConcernCausePart {
	constructor(concern: string,
				cause: string,
				component: PartComponent,
				correctionEstimates: CorrectionEstimate[] = []) {
		this.correctionEstimates = correctionEstimates;
		this.customerConcern = concern;
		this.causeOfFailure = cause;
		this.component = component;
	}

	// Concern of the claim.
	public customerConcern: string = "";
	// Cause of the claim.
	public causeOfFailure: string = "";
	// Component with issue reported in the claim.
	public component: PartComponent;
	// Claim items group.
	public correctionEstimates: CorrectionEstimate[] = [];
}

